const faq_es = require('./faq.json')
export default faq_es